'use client';

import clsx from 'clsx';

import Link from '@commons/components/Link';
import Flex from '@commons/containers/Flex';
import { usePathname } from '@commons/i18n/navigation';
import type { DrupalBlock, DrupalLink } from '@commons/types/drupal';
import type { Spacing } from '@commons/types/styles';

import styles from './index.module.scss';

// Type definition for the Navigation block properties.

type Props = DrupalBlock<{
  gap: Spacing;
  links: DrupalLink[];
  direction: 'row' | 'column';
}>;

/**
 * Navigation system block component.
 */

const NavigationBlock = ({ content }: Props) => {
  const pathname = usePathname();

  const { links = [], gap = 'md', direction } = content;

  const classes = clsx(styles.navigation, styles[direction]);

  const renderedLinks = links.map(({ url, text }, index) => (
    <Link href={url} active={pathname === url} key={index}>
      {text}
    </Link>
  ));

  return (
    <Flex gap={gap} direction={direction} className={classes}>
      {renderedLinks}
    </Flex>
  );
};

export default NavigationBlock;
